import React from 'react';

export type ViewMode = 'overlay' | 'separate';

interface ViewToggleProps {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
  className?: string;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onChange,
  className = '',
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Chart View
      </label>
      <div className="inline-flex rounded-lg border border-slate-200/50 bg-white p-1 shadow-sm">
        <button
          type="button"
          onClick={() => onChange('overlay')}
          className={`
            relative inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-all
            ${
              viewMode === 'overlay'
                ? 'bg-primary-500 text-white shadow-sm'
                : 'text-gray-700 hover:bg-gray-50'
            }
          `}
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          Overlay
        </button>
        <button
          type="button"
          onClick={() => onChange('separate')}
          className={`
            relative inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-all
            ${
              viewMode === 'separate'
                ? 'bg-primary-500 text-white shadow-sm'
                : 'text-gray-700 hover:bg-gray-50'
            }
          `}
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2z" />
          </svg>
          Separate
        </button>
      </div>
      <p className="mt-1 text-xs text-gray-500">
        {viewMode === 'overlay'
          ? 'All ponds on one chart'
          : 'Each pond on its own chart'}
      </p>
    </div>
  );
};
